import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";

import Header from "./Components/Header";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import i18next from "i18next";

import FXWidget from "./Widgets/FXWidget";
import ChartWidget from "./Widgets/ChartWidget";
import NewsWidget from "./Widgets/NewsWidget";

import "./App.css";
import { getURLParameters } from "./lib/utils";
import ContactUS from "./Components/PopupWidget/ContactUs";
import Disclaimer from "./Components/PopupWidget/Disclaimer";
import FXPollsWidget from "./Widgets/FXPollsWidget";
import CalendarWidget from "./Widgets/CalendarWidget";
import CommentaryWidget from "./Widgets/CommentaryWidget";
import RiskDisclosure from "./Components/PopupWidget/RiskDisclosure";

const getCC = () => getURLParameters("cc");
const getlang = () => getURLParameters("lang");

export default class App extends Component<any, any> {
  cc = getCC() || "HK";
  lang = getlang() || "zh_HK";
  constructor(props: any) {
    super(props);
    this.state = {
      token: process.env.NODE_ENV === "development" ? "" : "",
      fontSize: "100%",
      showMenu: true,
      lang: this.lang,
      isCommentary: false,
    };
    this.changelang = this.changelang.bind(this);
    this.changeFontSize = this.changeFontSize.bind(this);
  }

  changeWidget = (isCommentary: boolean) => {
    this.setState({ isCommentary: isCommentary });
  };

  changelang(lang: string) {
    i18next.changeLanguage(lang).then(() => {
      this.setState({ lang: lang });
    });
  }

  changeFontSize(fontSize: string) {
    this.setState({
      fontSize: fontSize,
    });
  }

  convertlang(lang: string) {
    if (lang === "sc") {
      return "zh_CN";
    } else if (lang === "tc") {
      return "zh_HK";
    } else if (lang === "en") {
      return "en";
    } else {
      return "zh_HK";
    }
  }

  render() {
    var domain = "";
    if (process.env.NODE_ENV === "development") {
      domain = "https://stgmds1.trkd-hs.com";
    } else {
      domain = window.location.origin;
    }

    return (
      <div>
        <Header
          lang={this.lang}
          setlang={this.changelang}
          setfontsize={this.changeFontSize}
        />
        <Router basename={"/bochkfxibs"}>
          {/* {
            this.state.showMenu &&
            <Navbar lang={this.state.lang} cc={this.cc} />
          } */}
          <Switch>
            <Route
              exact
              path="/"
              render={() => (
                <Redirect
                  to={"/mktinfo?lang=" + this.state.lang + "&cc=" + this.cc}
                />
              )}
            />
            <Route
              path={"/mktinfo"}
              render={(props: any) => (
                <FXWidget
                  domain={domain}
                  lang={this.convertlang(this.state.lang)}
                  fontSize={this.state.fontSize}
                  token={this.state.token}
                  cc={this.cc}
                  {...props}
                  widget={this.changeWidget}
                />
              )}
            />
            <Route
              path={"/chart"}
              render={(props: any) => (
                <ChartWidget
                  domain={domain}
                  lang={this.convertlang(this.state.lang)}
                  fontSize={this.state.fontSize}
                  token={this.state.token}
                  cc={this.cc}
                  {...props}
                  widget={this.changeWidget}
                />
              )}
            />
            <Route
              path={"/news"}
              render={(props: any) => (
                <NewsWidget
                  domain={domain}
                  lang={this.convertlang(this.state.lang)}
                  fontSize={this.state.fontSize}
                  token={this.state.token}
                  cc={this.cc}
                  {...props}
                  widget={this.changeWidget}
                />
              )}
            />
            <Route
              path={"/fxpolls"}
              render={(props: any) => (
                <FXPollsWidget
                  domain={domain}
                  lang={this.convertlang(this.state.lang)}
                  fontSize={this.state.fontSize}
                  token={this.state.token}
                  cc={this.cc}
                  {...props}
                  widget={this.changeWidget}
                />
              )}
            />
            <Route
              path={"/calendar"}
              render={(props: any) => (
                <CalendarWidget
                  domain={domain}
                  lang={this.convertlang(this.state.lang)}
                  fontSize={this.state.fontSize}
                  token={this.state.token}
                  cc={this.cc}
                  {...props}
                  widget={this.changeWidget}
                />
              )}
            />
            <Route
              path={"/commentary"}
              render={(props: any) => (
                <CommentaryWidget
                  domain={domain}
                  lang={this.convertlang(this.state.lang)}
                  fontSize={this.state.fontSize}
                  token={this.state.token}
                  cc={this.cc}
                  {...props}
                  widget={this.changeWidget}
                />
              )}
            />
            <Route
              path={"/contactus"}
              render={(props: any) => (
                <ContactUS
                  lang={this.convertlang(this.state.lang)}
                  fontSize={this.state.fontSize}
                  token={this.state.token}
                  cc={this.cc}
                  {...props}
                />
              )}
            />
            <Route
              path={"/disclaimer"}
              render={(props: any) => (
                <Disclaimer
                  lang={this.convertlang(this.state.lang)}
                  fontSize={this.state.fontSize}
                  token={this.state.token}
                  cc={this.cc}
                  {...props}
                />
              )}
            />
            <Route
              path={"/riskDisclosure"}
              render={(props: any) => (
                <RiskDisclosure
                  lang={this.convertlang(this.state.lang)}
                  fontSize={this.state.fontSize}
                  token={this.state.token}
                  cc={this.cc}
                  {...props}
                />
              )}
            />
          </Switch>
        </Router>
        {window.location.href.includes("disclaimer") || window.location.href.includes("riskDisclosure")? (
          ""
        ) : (
          <Footer isCommentary={this.state.isCommentary} />
        )}
        
      </div>
    );
  }
}
